import {
  DriverUserPermissionSet,
  PaymentMethodTypePermissionSet,
  PermissionSetType,
  SidebarProductVisibilityPermissionSet,
  VehiclePermissionSet,
} from '../sets'
import { ChargePermissionSet } from '../sets/ChargePermissions'
import { FarePassPermissionSet } from '../sets/FarePassPermissions'
import { PaymentMethodPermissionSet } from '../sets/PaymentMethodPermissions'
import { PromoPermissionSet } from '../sets/PromoPermissions'
import { RequestPermissionSet } from '../sets/RequestPermissions'
import { ReviewPermissionSet } from '../sets/ReviewPermissions'
import { RiderUserPermissionSet } from '../sets/RiderUserPermissions'
import { ServicePermissionSet } from '../sets/ServicePermissions'
import { TicketPermissionSet } from '../sets/TicketPermissions'
import { TipPermissionSet } from '../sets/TipPermissions'
import { AdminMinimalRole } from './AdminMinimalRole'

export const FinanceManagerRole: PermissionSetType[] = [
  ...AdminMinimalRole,
  SidebarProductVisibilityPermissionSet.ShowOperationsProduct,
  SidebarProductVisibilityPermissionSet.ShowAnalyticsProduct,
  SidebarProductVisibilityPermissionSet.ShowAnalyzeProduct,

  RiderUserPermissionSet.View,
  DriverUserPermissionSet.View,
  DriverUserPermissionSet.Export,

  /* Ability to View Service/Fleet/Zone/Stop/TimeRule */
  ServicePermissionSet.View,

  /* All permissions for Promo */
  PromoPermissionSet.View,
  PromoPermissionSet.Write,
  PromoPermissionSet.Export,
  PromoPermissionSet.ApplyToUser,

  /* Able to view and manage FarePass */
  FarePassPermissionSet.View,
  FarePassPermissionSet.Write,
  FarePassPermissionSet.ViewAllocation,
  FarePassPermissionSet.NewAllocation,
  FarePassPermissionSet.EditAllocation,
  FarePassPermissionSet.ImportAllocations,
  FarePassPermissionSet.ExportAllocations,

  /* Able to view and manage Tickets */
  TicketPermissionSet.ViewInstance,
  TicketPermissionSet.WriteInstance,
  TicketPermissionSet.DeleteInstance,

  /* Ability to see request information and discounts */
  RequestPermissionSet.View,
  RequestPermissionSet.ViewDiscounts,
  RequestPermissionSet.ViewDailyCounts,

  /* Ability to view reviews */
  ReviewPermissionSet.View,

  /* Ability to view tips */
  TipPermissionSet.View,

  /* Ability to view and refund charges */
  ChargePermissionSet.View,
  ChargePermissionSet.Refund,

  /* Ability to view payment methods collected and export data */
  PaymentMethodPermissionSet.View,
  PaymentMethodPermissionSet.Export,
  PaymentMethodPermissionSet.CollectDirectly,
  PaymentMethodPermissionSet.InitiatePhoneCollection,
  PaymentMethodPermissionSet.Delete,

  /* Ability to view vehicles */
  VehiclePermissionSet.View,

  /* Ability to view payment method types */
  PaymentMethodTypePermissionSet.View,
]
